//importing sections
import { Contact, Projects, Hero, Skills, About } from "./sections";
import { useState, useEffect } from "react";
import Preloader from "./components/Preloader";
function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  if (loading) return <Preloader />;
  else
    return (
      <>
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </>
    );
}

export default App;
